<template>
  <div class="mp_swiper" @mouseenter="paused = true" @mouseleave="paused = false">
    <div class="mp_swiper_track" :style="{ transform: 'translateX(-' + index * 100 + '%)' }">
      <div class="mp_swiper_item" v-for="(item, i) in list" :key="i">
        <img v-if="item.type === 'image'" class="mp_swiper_img" :src="item.url" alt="" @click="next" />
        <video v-else class="mp_swiper_video" :src="item.url" controls></video>
      </div>
    </div>

    <template v-if="list.length > 1">
      <div class="mp_swiper_arrow mp_arrow_left" @click="prev">
        <Icon type="ios-arrow-back" />
      </div>
      <div class="mp_swiper_arrow mp_arrow_right" @click="next">
        <Icon type="ios-arrow-forward" />
      </div>

      <div class="mp_swiper_dots">
        <span v-for="(item, i) in list" :key="i" class="mp_dot"
          :class="{ mp_dot_active: i === index }" @click="go(i)"></span>
      </div>
    </template>
  </div>
</template>

<script>
// 自动轮播的默认间隔（毫秒）
const DEFAULT_INTERVAL = 3500;

export default {
  name: "MpSwiper",
  props: {
    // 轮播项：[{ url, type }]，type 为 image / video
    list: {
      type: Array,
      default: () => [],
    },
    // 是否自动轮播（视频建议关闭，避免看到一半被切走）
    autoplay: {
      type: Boolean,
      default: true,
    },
    // 自动轮播间隔
    interval: {
      type: Number,
      default: DEFAULT_INTERVAL,
    },
  },
  data() {
    return {
      index: 0,
      // 鼠标悬停时暂停自动轮播
      paused: false,
      timer: null,
    };
  },
  watch: {
    // 列表变化后下标越界则回到第一项
    list() {
      if (this.index > this.list.length - 1) {
        this.index = 0;
      }
    },
  },
  mounted() {
    this.start_autoplay();
  },
  beforeUnmount() {
    this.stop_autoplay();
  },
  methods: {
    next() {
      var len = this.list.length;
      if (len > 1) {
        this.index = (this.index + 1) % len;
      }
    },

    prev() {
      var len = this.list.length;
      if (len > 1) {
        this.index = (this.index - 1 + len) % len;
      }
    },

    go(i) {
      this.index = i;
    },

    start_autoplay() {
      if (!this.autoplay) {
        return;
      }
      this.timer = setInterval(() => {
        if (this.paused || this.list.length <= 1) {
          return;
        }
        this.next();
      }, this.interval);
    },

    stop_autoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style scoped>
.mp_swiper {
  position: relative;
  margin-top: 8px;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f2f2f2;
}

/* 滑动轨道：每项占满一屏，靠 translateX 切换 */
.mp_swiper_track {
  display: flex;
  transition: transform 0.35s ease;
}

.mp_swiper_item {
  width: 100%;
  flex-shrink: 0;
}

.mp_swiper_img {
  width: 100%;
  height: 170px;
  object-fit: cover;
  display: block;
  cursor: pointer;
  background-color: #f2f2f2;
}

.mp_swiper_video {
  width: 100%;
  height: 170px;
  display: block;
  object-fit: contain;
  background-color: #000;
}

.mp_swiper_arrow {
  position: absolute;
  top: 50%;
  margin-top: -13px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.32);
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.mp_swiper_arrow:hover {
  background-color: rgba(0, 0, 0, 0.55);
}

.mp_arrow_left {
  left: 8px;
}

.mp_arrow_right {
  right: 8px;
}

.mp_swiper_dots {
  position: absolute;
  bottom: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mp_dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  margin: 0 3px;
  cursor: pointer;
}

.mp_dot_active {
  width: 12px;
  border-radius: 3px;
  background-color: #fff;
}
</style>
